var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("NuHomeCloneProductCarousel", {
        attrs: {
          title: _vm.title,
          "product-ids": _vm.productIds,
          country: _vm.country,
          language: _vm.language,
          "force-loading": _vm.loading,
          referrer: "product_recommendation_carousel",
        },
        on: { "click-pdp": _vm.onClickPdp, "click-atc": _vm.onClickAddToCart },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }